import { z } from 'zod';

import { UserPublic } from './user.js';

export const LoginRequest = z.object({
  email: z.string().email(),
  password: z.string().min(1),
  totp: z
    .string()
    .regex(/^\d{6}$/, 'expected 6-digit TOTP code')
    .optional(),
});
export type LoginRequest = z.infer<typeof LoginRequest>;

export const LoginResponse = z.object({
  user: UserPublic.extend({ mfaEnabled: z.boolean() }),
  accessToken: z.string(),
  expiresIn: z.number().int().positive(),
});
export type LoginResponse = z.infer<typeof LoginResponse>;

export const MfaEnrollResponse = z.object({
  secret: z.string(),
  otpauthUrl: z.string(),
  recoveryCodes: z.array(z.string()),
});
export type MfaEnrollResponse = z.infer<typeof MfaEnrollResponse>;

export const MfaVerifyRequest = z.object({
  totp: z.string().regex(/^\d{6}$/),
});
export type MfaVerifyRequest = z.infer<typeof MfaVerifyRequest>;

export const MfaDisableRequest = z.object({
  password: z.string().min(1),
  totp: z.string().regex(/^\d{6}$/),
});
export type MfaDisableRequest = z.infer<typeof MfaDisableRequest>;

export const PasswordResetRequest = z.object({
  token: z.string().min(20),
  newPassword: z.string().min(12).max(128),
});
export type PasswordResetRequest = z.infer<typeof PasswordResetRequest>;

export const PasswordChangeRequest = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(12).max(128),
});
export type PasswordChangeRequest = z.infer<typeof PasswordChangeRequest>;
